import { useSearchParams } from 'react-router-dom';

export const getQueryString = (params: URLSearchParams) =>
  `?${params.toString()}`;

export default function useQueryParams() {
  const [searchParams] = useSearchParams();

  return searchParams;
}
